module.exports = __webpack_public_path__ + "img/download.2ab6cecf.svg";